import { Trans, useTranslation } from 'react-i18next';
import { CSSProperties, useState } from 'react';
import { motion } from 'framer-motion';

import PageShape from '@/components/common/svg/shapes/PageShape.tsx';
import SadSmileShape from '@/components/common/svg/shapes/SadSmileShape.tsx';
import SearchShape from '@/components/common/svg/shapes/SearchShape.tsx';
import {
  buttonStyles,
  buttonTextStyles,
  containerStyles,
  dotLeftBottom,
  dotLeftTop,
  dotRightTop,
  headerTextStyles,
  iconsContainerStyles,
  textStyles
} from '@/components/Discovery/Card/placeholders/styles.ts';
import { useProfileStore } from '@/store/useProfileStore.ts';
import Modal from '@/animations/Modal.tsx';
import SearchFiltersModal from '@/components/Discovery/SearchFiltersModal.tsx';

const NoResults = () => {
  const { t } = useTranslation();
  const { aboutMe } = useProfileStore();

  const [showFilters, setShowFilters] = useState(false);

  const age_filter_min = aboutMe?.profile.age_filter_min ?? 18;
  const age_filter_max = aboutMe?.profile.age_filter_max ?? 60;

  const isPossibleToExpandSearch = age_filter_min > 18 || age_filter_max < 60;

  const openFilters = () => setShowFilters(true);
  const closeFilters = () => setShowFilters(false);

  return (
    <div style={containerStyles}>
      <div style={iconsContainerStyles}>
        <PageShape
          width={100}
          height={100}
          fillColor="#505050"
          style={{
            marginTop: '0px',
            transform: 'rotate(15deg)'
          }}
        />
        <SearchShape
          width={60}
          height={60}
          fillColor="#e0e0e0"
          style={{
            position: 'absolute',
            left: '26px',
            top: '26px'
          }}
        />
        <div style={secondaryShapeBg} />
        <SadSmileShape
          width={35}
          height={35}
          fillColor="#b0b0b0"
          style={{
            position: 'absolute',
            top: '33px',
            left: '33px'
          }}
        />
        <div style={dotLeftBottom} />
        <div style={dotLeftTop} />
        <div style={dotRightTop} />
      </div>

      <h2 style={headerTextStyles}>
        {t('discovery.card.placeholder.empty.header')}
      </h2>
      <p style={textStyles}>
        <Trans
          i18nKey={
            isPossibleToExpandSearch
              ? 'discovery.card.placeholder.empty.text.with_age_filter'
              : 'discovery.card.placeholder.empty.text'
          }
          components={{
            br: <br />
          }}
        />
      </p>

      {isPossibleToExpandSearch && (
        <motion.div
          whileTap={{ scale: 0.9 }}
          onClick={openFilters}
          onTap={openFilters}
          style={buttonStyles}
        >
          <span style={buttonTextStyles}>
            {t('discovery.card.placeholder.empty.text.btn_label')}
          </span>
        </motion.div>
      )}
      <Modal open={showFilters} handleClose={closeFilters}>
        <SearchFiltersModal onClose={closeFilters} />
      </Modal>
    </div>
  );
};

const secondaryShapeBg: CSSProperties = {
  position: 'absolute',
  width: '36px',
  height: '36px',
  borderRadius: '20px',
  background: '#505050',
  top: '33px',
  left: '33px'
};

export default NoResults;
